import React, { ReactElement, useState } from "react";
import useKeyboardShortcuts from "../../../contexts/KeyboardShortcutContext";
import useSelectionState, { Ticket } from "../../../pages/agent/selection-state";
import { ChatStatus, useSnoozeMutation } from "../../../__generated__/api";
import Scheduler from "../../scheduler/Scheduler";

export default function Snooze(): ReactElement {
    const selectionState = useSelectionState();
    const [sendSnooze] = useSnoozeMutation();
    const [isShow, setShouldShow] = useState(false);

    const [lastIgnored, setLastIgnored] = useState<Ticket[]>([]);

    const snooze = (tickets?: Ticket[]) => {
        const selection = tickets ?? selectionState
            .getSelection()
            .filter(ticket => ticket.status === ChatStatus.Assigned);

        setLastIgnored(selection);
        setShouldShow(true);
    };

    const doSnooze = async (date: Date, note: string) => {
        const ids = lastIgnored.toIdList("id") as string[];
        await sendSnooze({
            variables: {
                ids,
                options: {
                    note,
                    date,
                },
            },

        });
        setShouldShow(false);
        selectionState.closeCurrent();
    };

    useKeyboardShortcuts(shortcuts => {
        shortcuts.on({
            shortcut: "k+s",
            context: "default",
            description: "Snooze the conversation",
            group: "Conversations",
            handler: () => snooze(),
        });
    });

    selectionState.registerSnooze(tickets => {
        snooze(tickets);
    });

    return (
        <div>
            <Scheduler
                confirmText="Snooze"
                shouldShow={isShow}
                isPresetAutoSelect={false}
                onCancel={() => setShouldShow(false)}
                canAddNotes
                onSelected={(date, _timezone, notes) => doSnooze(date, notes)}
            />
        </div>
    );
}

Snooze.defaultProps = {
    refreshData: () => {
        // nothing
    },
};
